export class AssinaturaModel {
    uuid: String;
    name: String;
    mimeType: String;
    isFile: boolean;
}


// WEBPACK FOOTER //
// /app/src/app/model/assinatura/assinatura.model.ts